import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  FaRegCommentDots,
  FaUsers,
  FaUserCog,
  FaThLarge,
  FaChartLine,
  FaBook,
} from 'react-icons/fa';
import PortalNavbar from './PortalNavbar';
import './Hub.css';

/**
 * Entry point del portale: l'utente sceglie una sezione.
 * Replica il mockup di riferimento (card 2x2 centrata).
 * Tutte le card navigano verso rotte reali e registrate in App.js.
 */
const SECTIONS = [
  {
    key: 'chat',
    title: 'Chat',
    desc: 'Ricerca candidati e conversazioni',
    to: '/chat',
    icon: <FaRegCommentDots />,
    tone: 'blue',
  },
  {
    key: 'candidati',
    title: 'Gestione Candidati',
    desc: 'Anagrafica e profili CV',
    to: '/metadata',
    icon: <FaUsers />,
    tone: 'amber',
  },
  {
    key: 'utenti',
    title: 'Gestione Utenti',
    desc: 'Account, ruoli e permessi',
    to: '/users',
    icon: <FaUserCog />,
    tone: 'violet',
  },
  {
    key: 'dashboard',
    title: 'Dashboard',
    desc: 'Statistiche e analisi aziendale',
    to: '/dashboard',
    icon: <FaThLarge />,
    tone: 'green',
  },
];

function Hub() {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="hub-page">
      <PortalNavbar showLogout />

      <main className="hub-main">
        <section className="hub-card ds-card">
          <header className="hub-card-header">
            <h1 className="hub-greeting">{user?.username || 'Benvenuto'}</h1>
            <p className="hub-subtitle">Seleziona una sezione per continuare</p>
          </header>

          <div className="hub-grid">
            {SECTIONS.map((s) => (
              <button
                key={s.key}
                type="button"
                className="hub-tile ds-card ds-card-interactive"
                onClick={() => navigate(s.to)}
              >
                <span className={`hub-tile-icon tone-${s.tone}`}>{s.icon}</span>
                <span className="hub-tile-title">{s.title}</span>
                <span className="hub-tile-desc">{s.desc}</span>
              </button>
            ))}
          </div>

          {/* Riservate al ruolo HR (e Admin) — il backend le protegge già con
              require_hr su ogni endpoint reale; qui nascondiamo il bottone
              per chi comunque riceverebbe 403, così la UI mostra solo ciò
              che il ruolo consente, coerentemente con quanto deciso da
              Armando il 30/09. */}
          {['hr', 'admin'].includes(user?.role) && (
            <button
              type="button"
              className="hub-bigbtn"
              onClick={() => navigate('/dashboard-multifitting')}
            >
              <span className="hub-bigbtn-icon"><FaChartLine /></span>
              <span className="hub-bigbtn-text">
                <span className="hub-bigbtn-title">Dashboard MultiFitting</span>
                <span className="hub-bigbtn-desc">Ranking candidati, cluster e annunci · fitting cross-cluster</span>
              </span>
              <span className="hub-bigbtn-arrow">→</span>
            </button>
          )}

          {/* Blocco "Nuovi moduli — MVP 2026 DEMO" e modulo Self-Assessment
              rimossi il 27/09, su richiesta esplicita. */}

          {['hr', 'admin'].includes(user?.role) && (
            <button
              type="button"
              className="hub-bigbtn hub-bigbtn--outline"
              onClick={() => navigate('/self-assessment/console')}
            >
              <span className="hub-bigbtn-icon"><FaChartLine /></span>
              <span className="hub-bigbtn-text">
                <span className="hub-bigbtn-title">Console HR — Stato Self-Assessment</span>
                <span className="hub-bigbtn-desc">Elenco generale dei consulenti e stato del loro Self-Assessment</span>
              </span>
              <span className="hub-bigbtn-arrow">→</span>
            </button>
          )}

          <button
            type="button"
            className="hub-bigbtn hub-bigbtn--outline"
            onClick={() => navigate('/knowledge-management')}
          >
            <span className="hub-bigbtn-icon"><FaBook /></span>
            <span className="hub-bigbtn-text">
              <span className="hub-bigbtn-title">Knowledge Management</span>
              <span className="hub-bigbtn-desc">Esperienze, ricerca semantica e schede per uso commerciale</span>
            </span>
            <span className="hub-bigbtn-arrow">→</span>
          </button>
        </section>
      </main>
    </div>
  );
}

export default Hub;
